import React from 'react';
import styled from "styled-components";
import {device} from "./Devices";

function HobbyPage ({image, title, description}) {

    return (

        <Code_Item>
            <img src={image} alt=""/>
            <h1>{title}</h1>
            <p>{description}</p>
        </Code_Item>

    );
}

export default HobbyPage;

const Code_Item = styled.div`

  width: 250px;
  height: 550px;
  padding: 20px;
  //border: 1px solid var(--blackShadow);
  background-color: var(--dimGrey);
  border-radius: 2px;
  box-shadow: 5px 5px 25px var(--dimGrey);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 15px;
  
  @media ${device.tablet} {
    //margin: 0 60px;


  }

  img {
    width: 220px;
    height: 220px;
  }

  h1 {
    color: var(--mainTextColor);
    width: 220px;
    margin: 30px 0;
  }

  p {
    color: var(--blackShadow);
    width: 220px;
  }


`;